import { render, staticRenderFns } from "./ColourPaletteList.vue?vue&type=template&id=aa6e4282&scoped=true&"
import script from "./ColourPaletteList.vue?vue&type=script&lang=ts&"
export * from "./ColourPaletteList.vue?vue&type=script&lang=ts&"
import style0 from "./ColourPaletteList.vue?vue&type=style&index=0&id=aa6e4282&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa6e4282",
  null
  
)

export default component.exports